import { render } from "./edittemplate.vue?vue&type=template&id=332a0e4c&scoped=true"
import script from "./edittemplate.vue?vue&type=script&lang=js"
export * from "./edittemplate.vue?vue&type=script&lang=js"

import "./edittemplate.vue?vue&type=style&index=0&id=332a0e4c&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332a0e4c"]])

export default __exports__